<template>
  <b-navbar
    toggleable="lg"
    class="navbar navbar-expand-lg navbar-light navbar--custom"
  >
    <div class="container">
      <router-link class="navbar-brand" to="/">
        <img
          src="./../assets/images/logo-videomedi.png"
          alt="Logotipo do Videomedi"
          @click="callClearFilter"
        />
      </router-link>
      <b-navbar-toggle
        class="navbar-toggler"
        data-toggle="collapse"
        target="nav-collapse"
      >
        <div class="animated-icon">
          <span />
          <span />
          <span />
          <span />
        </div>
      </b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="navbar-nav ml-auto">
          <b-nav-item class="nav-item">
            <span class="sr-only">(current)</span>
          </b-nav-item>
          <b-nav-item class="nav-item">
            <RouterLink class="nav-link" to="/">
              Profissionais de saúde
            </RouterLink>
          </b-nav-item>
          <b-nav-item class="nav-item">
            <RouterLink class="nav-link" to="/clinicas">Clínicas</RouterLink>
          </b-nav-item>
          <ProfileDropdown
            v-if="loggedIn"
            :component-tag="this.$options._componentTag"
          />
          <b-nav-item v-else class="nav-item nav-item--custom">
            <RouterLink class="nav-link" to="/login">Entrar</RouterLink>
          </b-nav-item>
        </b-navbar-nav>
        <RouterLink v-if="!loggedIn" to="/cadastrar" class="button1">
          Crie uma conta
        </RouterLink>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
import { authComputed } from "./../state/helpers";
import ProfileDropdown from "../components/ProfileDropdown";
export default {
  name: "TopBar",
  components: {
    ProfileDropdown
  },
  methods: {
    callClearFilter() {
      this.$emit("clear-filter");
    }
  },
  computed: {
    ...authComputed
  }
};
</script>

<style>
.navbar a.nav-link .nav-link {
  padding: 0 0 !important;
}
</style>
